import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import globals from '../globals';
import analytics from '../lib/analytics';

const delay = 200;
const channelBase = 'https://app.marblever.se/channel';
const { channels } = globals;

const Forwards = () => {
  const params = useParams();
  const navigate = useNavigate();
  const channelId = params._id;
  const channel = channelId && channels[channelId];
  if (channel) {
    try {
      analytics.trackEvent({ eventName: channel.eventName });
    } catch {}
    window.setTimeout(() => (document.location.href = `${channelBase}/${channel._id}`), delay);
  } else {
    window.setTimeout(() => navigate('/'), delay);
  }
  return <div className="forward" />;
};

export default Forwards;
